import { render, staticRenderFns } from "./step-reading-invoice.vue?vue&type=template&id=f5925582&scoped=true&"
import script from "./step-reading-invoice.vue?vue&type=script&lang=js&"
export * from "./step-reading-invoice.vue?vue&type=script&lang=js&"
import style0 from "./step-reading-invoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./step-reading-invoice.vue?vue&type=style&index=1&id=f5925582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5925582",
  null
  
)

export default component.exports